(function () {
  'use strict';
  if (window.MLVTestimonials) return;

  var instances = new Map();

  function mount(root) {
    if (instances.has(root)) return;
    var track = root.querySelector('[data-review-track]');
    var cards = Array.from(root.querySelectorAll('[data-review-card]'));
    var controls = root.querySelector('[data-review-controls]');
    if (!track || !controls || !cards.length) return;

    var previous = controls.querySelector('[data-review-previous]');
    var next = controls.querySelector('[data-review-next]');
    var choices = Array.from(controls.querySelectorAll('[data-review-select]'));
    var status = controls.querySelector('[data-review-status]');
    var compact = window.matchMedia('(max-width: 900px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var index = 0;
    var scrollFrame = 0;
    var listeners = [];

    function listen(target, event, handler, options) {
      target.addEventListener(event, handler, options);
      listeners.push(function () { target.removeEventListener(event, handler, options); });
    }

    function pauseOtherVideos(active) {
      cards.forEach(function (card, i) {
        var video = card.querySelector('video');
        if (video && i !== active && !video.paused) video.pause();
      });
    }

    function update() {
      controls.hidden = !compact.matches;
      previous.disabled = index === 0;
      next.disabled = index === cards.length - 1;
      choices.forEach(function (button, i) {
        if (i === index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      status.textContent = 'Vidéo ' + (index + 1) + ' sur ' + cards.length + ' · ' + cards[index].dataset.reviewName;
      if (compact.matches) {
        track.setAttribute('tabindex', '0');
        track.setAttribute('aria-roledescription', 'carrousel');
      } else {
        track.removeAttribute('tabindex');
        track.removeAttribute('aria-roledescription');
      }
    }

    function select(target, instant) {
      index = Math.max(0, Math.min(cards.length - 1, target));
      if (compact.matches) {
        pauseOtherVideos(index);
        var viewport = track.getBoundingClientRect();
        var card = cards[index].getBoundingClientRect();
        var left = track.scrollLeft + card.left + card.width / 2 - viewport.left - viewport.width / 2;
        track.scrollTo({ left: left, behavior: instant || reducedMotion.matches ? 'auto' : 'smooth' });
      }
      update();
    }

    function syncScroll() {
      scrollFrame = 0;
      if (!compact.matches) return;
      var viewport = track.getBoundingClientRect();
      var center = viewport.left + viewport.width / 2;
      var closest = 0;
      var distance = Infinity;
      cards.forEach(function (card, i) {
        var bounds = card.getBoundingClientRect();
        var gap = Math.abs(bounds.left + bounds.width / 2 - center);
        if (gap < distance) { distance = gap; closest = i; }
      });
      if (closest !== index) {
        index = closest;
        pauseOtherVideos(index);
        update();
      }
    }

    listen(track, 'scroll', function () {
      if (!scrollFrame) scrollFrame = window.requestAnimationFrame(syncScroll);
    }, { passive: true });
    listen(previous, 'click', function () { select(index - 1); });
    listen(next, 'click', function () { select(index + 1); });
    choices.forEach(function (button, i) {
      listen(button, 'click', function () { select(i); });
    });
    listen(root, 'keydown', function (event) {
      if (!compact.matches || (event.target !== track && !controls.contains(event.target))) return;
      var target;
      if (event.key === 'ArrowRight') target = index + 1;
      else if (event.key === 'ArrowLeft') target = index - 1;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = cards.length - 1;
      else return;
      event.preventDefault();
      select(target);
    });
    listen(track, 'focusin', function (event) {
      var card = event.target.closest('[data-review-card]');
      if (card && compact.matches) select(cards.indexOf(card), true);
    });
    // Capture phase also handles videos created after the carousel mounted.
    // Retains native-video behavior on landing pages sharing this asset.
    listen(track, 'play', function (event) {
      if (event.target.tagName !== 'VIDEO') return;
      var card = event.target.closest('[data-review-card]');
      var frame = event.target.closest('.hp-video-frame');
      if (card) pauseOtherVideos(cards.indexOf(card));
      if (frame) frame.classList.add('is-playing');
    }, true);
    ['pause', 'ended'].forEach(function (eventName) {
      listen(track, eventName, function (event) {
        if (event.target.tagName !== 'VIDEO') return;
        var frame = event.target.closest('.hp-video-frame');
        if (frame) frame.classList.remove('is-playing');
      }, true);
    });
    listen(document, 'visibilitychange', function () {
      if (document.hidden) pauseOtherVideos(-1);
    });
    function resize() { if (compact.matches) select(index, true); }
    listen(compact, 'change', function () { select(index, true); });
    var observer = window.ResizeObserver ? new ResizeObserver(resize) : null;
    if (observer) observer.observe(track);
    else listen(window, 'resize', resize);

    root.classList.add('is-ready');
    update();
    instances.set(root, function () {
      pauseOtherVideos(-1);
      listeners.forEach(function (remove) { remove(); });
      if (observer) observer.disconnect();
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      root.classList.remove('is-ready');
      controls.hidden = true;
      track.removeAttribute('tabindex');
      track.removeAttribute('aria-roledescription');
      instances.delete(root);
    });
  }

  function init(container) {
    if (container.matches && container.matches('[data-mlv-reviews]')) mount(container);
    container.querySelectorAll('[data-mlv-reviews]').forEach(mount);
  }

  window.MLVTestimonials = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, root) {
      if (event.target.contains(root)) destroy();
    });
  });
}());
